export enum LOCAL_STORAGE {
  AccessToken = "access_token",
  RefreshToken = "refresh_token",
  SessionId = "session_id",
  TelegramId = "telegram_id",
  UserId = "user_id",
  Name = "name",
  IsNewProfile = "is_new_profile",
}
